import React from 'react';
import { Link } from 'react-router-dom';
import { ROUTES } from '../data/constants';
import { TwitterIcon, FacebookIcon, InstagramIcon, EmailIcon } from './icons/SocialIcons';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-main">
          <div className="footer-brand">
            <img src="/images/furever-logo-white.png" alt="FurEver" className="footer-logo-img" />
            <p className="footer-tagline">
              Premium products for your beloved pets. Quality, care, and love in every item.
            </p>
            <div className="footer-social">
              <span className="social-icon"><TwitterIcon /></span>
              <span className="social-icon"><FacebookIcon /></span>
              <span className="social-icon"><InstagramIcon /></span>
              <span className="social-icon"><EmailIcon /></span>
            </div>
          </div>

          <div className="footer-links-group">
            <h4>Explore</h4>
            <Link to={ROUTES.PRODUCTS}>Products</Link>
            <Link to={ROUTES.REVIEWS}>Reviews</Link>
          </div>

          <div className="footer-links-group">
            <h4>Categories</h4>
            <Link to={`${ROUTES.PRODUCTS}?category=Food`}>Food</Link>
            <Link to={`${ROUTES.PRODUCTS}?category=Treats`}>Treats</Link>
            <Link to={`${ROUTES.PRODUCTS}?category=Health`}>Health</Link>
            <Link to={`${ROUTES.PRODUCTS}?category=Accessories`}>Accessories</Link>
          </div>

          <div className="footer-links-group">
            <h4>Pets</h4>
            <Link to={`${ROUTES.PRODUCTS}?petType=Dog`}>Dogs</Link>
            <Link to={`${ROUTES.PRODUCTS}?petType=Cat`}>Cats</Link>
            <Link to={`${ROUTES.PRODUCTS}?petType=Bird`}>Birds</Link>
            <Link to={`${ROUTES.PRODUCTS}?petType=Small Animal`}>Small Animals</Link>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} FurEver. Made with ❤️ for pets everywhere.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
